import { render, staticRenderFns } from "./DisOrderNew.vue?vue&type=template&id=bc5ebbc2&scoped=true&"
import script from "./DisOrderNew.vue?vue&type=script&lang=js&"
export * from "./DisOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./DisOrderNew.vue?vue&type=style&index=0&id=bc5ebbc2&lang=less&scoped=scoped&"
import style1 from "./DisOrderNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5ebbc2",
  null
  
)

export default component.exports